<template>
  <div class="warrantDialog">
    <el-dialog
      title="编辑"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="open"
      :before-close="closeForm"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-row>
            <el-form-item label="机构名称" prop="orgName">
              <el-input
                v-model="ruleForm.orgName"
                placeholder="请输入机构名称"
                :disabled="isDisabled"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构简称" prop="orgAbbreviation">
              <el-input
                v-model="ruleForm.orgAbbreviation"
                placeholder="请输入机构简称"
                :disabled="isDisabled"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="成立时间" prop="orgEstablishmentDate">
              <el-date-picker
                v-model="ruleForm.orgEstablishmentDate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="请选择成立时间"
                style="text-align: left;width:100%"
                clearable
                :disabled="isDisabled"
              ></el-date-picker>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构类型" prop="orgType">
              <el-select
                v-model="ruleForm.orgType"
                placeholder="请选择机构类型"
                clearable
                style="display: block;"
                :disabled="isDisabled"
                @change="selectChange($event, orgTypeList, 'orgTypeName')"
              >
                <el-option
                  :label="item.label"
                  :value="item.id"
                  v-for="item in orgTypeList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="投资阶段" prop="investmentStage">
              <el-select
                v-model="ruleForm.investmentStage"
                placeholder="请选择投资阶段"
                clearable
                style="display: block;"
                :disabled="isDisabled"
                @change="selectChange($event, investmentList, 'investmentStageName')"
              >
                <el-option
                  :label="item.label"
                  :value="parseInt(item.value)"
                  v-for="item in investmentList"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="投资领域" prop="investmentAreas">
              <el-select
                v-model="ruleForm.investmentAreas"
                placeholder="请选择投资领域"
                clearable
                multiple
                style="display: block;"
                :disabled="isDisabled"
                @clear="clearInvest"
              >
                <el-option label="新能源" :value="'新能源'"></el-option>
                <el-option label="现代农业" :value="'现代农业'"></el-option>
                <el-option label="生物医药" :value="'生物医药'"></el-option>
                <el-option label="文化旅游" :value="'文化旅游'"></el-option>
                <el-option label="通道物流" :value="'通道物流'"></el-option>
                <el-option label="军民融合" :value="'军民融合'"></el-option>
                <el-option label="数据信息" :value="'数据信息'"></el-option>
                <el-option label="装备制造" :value="'装备制造'"></el-option>
                <el-option label="新材料" :value="'新材料'"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构地址" prop="orgProvince">
              <v-distpicker
                style="text-align:left;"
                @selected="citySelected"
                :province="ruleForm.orgProvince"
                :city="ruleForm.orgCity"
                :area="ruleForm.orgDistrict"
                :disabled="isDisabled"
              ></v-distpicker>
            </el-form-item>
            <el-form-item prop="orgAddress">
              <el-input
                v-model="ruleForm.orgAddress"
                placeholder="请填写详细地址"
                :disabled="isDisabled"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构简介" prop="orgDescription">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入机构简介"
                v-model="ruleForm.orgDescription"
                :disabled="isDisabled"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="ruleForm.contactPerson"
                placeholder="请输入联系人"
                :disabled="isDisabled"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系方式" prop="contactInfo">
              <el-input
                v-model="ruleForm.contactInfo"
                placeholder="请输入联系方式"
                :disabled="isDisabled"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="logo" prop="logoSrc">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                :file-list="logoSrc"
                :before-upload="beforeAvatarUpload"
                :disabled="isDisabled"
                :limit="limit"
                ref="upload0"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'logoSrc')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!isDisabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'logoSrc')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="el-upload__tip" v-if="showUpload1 && !isDetail">
                  只允许上传一张图片
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="实景图" prop="realImageSrc">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                :file-list="realImageSrc"
                :before-upload="beforeAvatarUpload"
                :disabled="isDisabled"
                :limit="limit"
                ref="upload1"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'realImageSrc')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!isDisabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'realImageSrc')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="el-upload__tip" v-if="showUpload2 && !isDetail">
                  只允许上传一张图片
                </div>
              </el-upload>
            </el-form-item>
          </el-row>

          <el-row>
            <el-form-item label="成功案例(logo)" prop="successCaseLogoSrc">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                :file-list="successCaseLogoSrc"
                :before-upload="beforeAvatarUpload"
                :disabled="isDisabled"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'successCaseLogoSrc')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!isDisabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'successCaseLogoSrc')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="是否发布" prop="publishedFlag" style="text-align:left">
              <el-switch
                v-model="ruleForm.publishedFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="isDisabled"
              ></el-switch>
            </el-form-item>
            <el-form-item label="审批状态" prop="approvalStatus" style="text-align:left">
              <el-select
                v-model="ruleForm.approvalStatus"
                placeholder="请选择审核状态"
                :disabled="isDisabled"
                style="display: block;"
              >
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="不通过" :value="2"></el-option>
                <el-option label="退回" :value="3"></el-option>
                <el-option label="通过" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="updateSubmitForm('ruleForm')">
          修 改
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :append-to-body="true" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import commonUpload from '@/components/common-upload.vue';
export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    queryId: {
      type: Number | String,
      default: ''
    }
  },
  components: {
    commonUpload
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      logoSrc: [],
      realImageSrc: [],
      successCaseLogoSrc: [],
      investmentList: [],
      showUpload1: false,
      showUpload2: false,
      orgTypeList: [],
      ruleForm: {
        //1投资机构,2金融服务机构,3担保机构
        dataType: 1,
        orgName: null, // 机构名称
        orgAbbreviation: null, // 机构简称
        orgDescription: null, // 机构简介
        orgEstablishmentDate: null, // 成立时间
        orgType: null, // 机构类型id
        orgTypeName: null, // 机构类型name
        investmentStage: null, // 投资阶段id
        investmentStageName: null, // 投资阶段name
        orgProvince: null, // 通讯地址-省
        orgCity: null, // 通讯地址-市
        orgDistrict: null, // 通讯地址-区
        orgAddress: null, // 通讯地址-详细地址
        contactPerson: null, // 联系人
        contactInfo: null, // 联系方式
        logoSrc: null, // logo
        realImageSrc: null, // 实景图
        successCaseLogoSrc: null, // 成功案例logo
        publishedFlag: 0, // 是否发布
        approvalStatus: 1,
        investmentAreas: []
      },
      limit: 1,
      rules: {
        orgName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        orgAbbreviation: [{ required: true, message: '请输入机构简称', trigger: 'blur' }],
        orgDescription: [{ required: true, message: '请输入机构简介', trigger: 'blur' }],
        orgEstablishmentDate: [{ required: true, message: '请选择成立时间', trigger: 'change' }],
        orgType: [{ required: true, message: '请选择机构类型', trigger: 'change' }],
        investmentStage: [{ required: true, message: '请选择投资阶段', trigger: 'change' }],
        orgProvince: [{ required: true, message: '请选择机构地址-省', trigger: 'change' }],
        orgCity: [{ required: true, message: '请选择机构地址-市', trigger: 'change' }],
        orgDistrict: [{ required: true, message: '请选择机构地址-区', trigger: 'change' }],
        orgAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactInfo: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        logoSrc: [{ required: true, message: '请上传logo图片', trigger: ['blur', 'change'] }],
        realImageSrc: [{ required: true, message: '请上传实景图', trigger: ['blur', 'change'] }],
        successCaseLogoSrc: [
          { required: true, message: '请上传成功案例logo', trigger: ['blur', 'change'] }
        ],
        publishedFlag: [{ required: true, message: '请选择是否发布', trigger: ['blur', 'change'] }],
        approvalStatus: [{ required: true, message: '请选择审批状态', trigger: ['blur', 'change'] }]
      }
    };
  },
  computed: {
    isDisabled() {
      return this.ruleForm.approvalStatus === 4;
    }
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logoSrc: {
      handler() {
        this.checkLimit(this.logoSrc, 0);
      }
    },
    realImageSrc: {
      handler() {
        this.checkLimit(this.realImageSrc, 1);
      }
    }
  },
  methods: {
    clearInvest() {
      this.ruleForm.investmentAreas = [];
    },
    selectChange(e, list, props) {
      if (e) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = '';
      }
      console.log('this.ruleForm[props]', this.ruleForm[props]);
    },
    async open() {
      console.log('openopenopen');
      this.getSiftList(['financial_institution_category', 'financial_investment_stage']);

      this.ruleForm = {
        //1投资机构,2金融服务机构,3担保机构
        dataType: 1,
        orgName: null, // 机构名称
        orgAbbreviation: null, // 机构简称
        orgDescription: null, // 机构简介
        orgEstablishmentDate: null, // 成立时间
        orgType: null, // 机构类型id
        orgTypeName: null, // 机构类型name
        investmentStage: null, // 投资阶段id
        investmentStageName: null, // 投资阶段name
        orgProvince: null, // 通讯地址-省
        orgCity: null, // 通讯地址-市
        orgDistrict: null, // 通讯地址-区
        orgAddress: null, // 通讯地址-详细地址
        contactPerson: null, // 联系人
        contactInfo: null, // 联系方式
        logoSrc: null, // logo
        realImageSrc: null, // 实景图
        successCaseLogoSrc: null, // 成功案例logo
        publishedFlag: 0, // 是否发布
        approvalStatus: 1,
        investmentAreas: []
      };
      this.getDetail();
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      console.log(this.$refs['upload' + index]);
      const uploadDom = this.$refs['upload' + index];
      if (filelist.length === limit) {
        uploadDom.$children[1].$el.style.display = 'none';
        this['showUpload' + (index + 1)] = true;
      } else {
        uploadDom.$children[1].$el.style.display = '';
        this['showUpload' + (index + 1)] = false;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        console.log(this.ruleForm.logoSrc);
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        console.log('  this.ruleForm[type]', this.ruleForm[type]);
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    orgChange(id) {
      const data = this.orgTypeList.find(item => item.id === id);
      this.ruleForm.orgTypeName = data.label;
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //城市选择
    citySelected(e) {
      console.log(e, 'e');
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 50MB!');
      }
      return type && isLt2M;
    },
    // 人才类别和从事技术领域
    getSiftList(type) {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
          dictTypes: type
        })
        .then(res => {
          if (res.code === 0) {
            this.orgTypeList = [...this.orgTypeList, ...res.data.financial_institution_category];
            this.investmentList = res.data.financial_investment_stage;
          }
        });
    },
    async getDetail() {
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          this.ruleForm = res.data;
          this.successCaseLogoSrc = res.data.successCaseLogoSrc
            ? JSON.parse(res.data.successCaseLogoSrc)
            : [];
          this.realImageSrc = res.data.realImageSrc ? JSON.parse(res.data.realImageSrc) : [];
          this.logoSrc = res.data.logoSrc ? JSON.parse(res.data.logoSrc) : [];
          this.ruleForm.investmentAreas = res.data.investmentAreas
            ? JSON.parse(res.data.investmentAreas)
            : [];
          if (this.ruleForm.orgType) {
            const orgItem = this.orgTypeList.find(item => item.id === this.ruleForm.orgType);
            if (!orgItem) {
              this.orgTypeList = [
                ...this.orgTypeList,
                {
                  id: this.ruleForm.orgType,
                  label: this.ruleForm.orgTypeName
                }
              ];
            }
          }
        } else {
          this.ruleForm = {
            dataType: 1,
            orgName: '',
            orgAbbreviation: '',
            orgEstablishmentDate: '',
            orgProvince: '',
            orgCity: '',
            orgDistrict: '',
            orgAddress: '',
            orgType: '',
            orgTypeName: '',
            orgDescription: '',
            contactInfo: '',
            logoSrc: '',
            publishedFlag: 0,
            approvalStatus: 1
          };
        }
      } catch (e) {
        console.log(e);
      }
    },
    updateSubmitForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 编辑提交
          this.editData();
        } else {
          return false;
        }
      });
    },
    closeForm() {
      this.$emit('close', false);
    },
    editData() {
      this.ruleForm.investmentAreas =
        this.ruleForm.investmentAreas.length > 0
          ? JSON.stringify(this.ruleForm.investmentAreas)
          : '[]';

      if (this.ruleForm.dtl) {
        this.$delete(this.ruleForm, 'dtl');
      }
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/update`, {
          ...this.ruleForm,
          dataType: 1
        })
        .then(res => {
          if (res.code === 0) {
            this.$emit('close', true);
            this.$message.success('编辑成功');
          } else {
            this.$messgae.error('编辑失败');
          }
        })
        .catch(e => {
          this.$messgae.error('编辑失败');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.warrantDialog {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .preview_btn {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(#000, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 26px;
    }
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    display: flex;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }
  .el-radio {
    display: flex;
    align-items: center;
  }

  .imgInput {
    background: url(../../../../assets/add.png) no-repeat;
    border: none;
    text-indent: -2000px;
    height: 120px;
    padding: 10px;
    background-size: 70%;
    background-position: center;
    color: white;
    cursor: pointer;
  }

  .imgInput:focus {
    border: none;
    outline: 0;
  }

  .allPics {
    border: 1px solid #ccc;
    padding: 18px 15px 10px 20px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
  }

  .allPics1 {
    display: flex;
    // flex-wrap: wrap;
  }

  .addPic-body {
    padding: 10px;
    height: 120px;
  }

  .addPic-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .addPic {
    max-width: 100%;
    max-height: 100%;
  }

  .el-form-item__content {
    text-align: left;
  }
  .form-title {
    width: 100%;
    text-align: left;
    color: #623aa2;
    border-left: 5px solid #623aa2;
    border-bottom: 1px solid #623aa2;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }
}
/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}

/deep/ .upload-demo {
  margin-top: 10px;
  /deep/.el-upload {
    /deep/.el-button {
      font-size: 14px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(66, 141, 255, 1);
      border-radius: 18px;
      padding: 10px 25px;
    }
  }
}
</style>
